import { useAuth0 } from "@auth0/auth0-react"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@components/ui/dropdown-menu"
import { ChevronDown } from "lucide-react"

export const NavbarUser = () => {
  const { user, logout } = useAuth0()

  const handleLogout = () => {
    logout({ logoutParams: { returnTo: window.location.origin } })
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <div className="tw:ml-auto tw:flex tw:items-center tw:justify-between tw:gap-2">
          <img
            referrerPolicy="no-referrer"
            src={user?.picture}
            className="tw:h-[35px] tw:w-[35px] tw:rounded-full"
            alt=""
          />
          <span>{user?.name}</span>
          <ChevronDown size={18} />
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="tw:w-36" align="start">
        <DropdownMenuItem onClick={handleLogout} className="tw:cursor-pointer">
          Sign out
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
